import { Component } from '@angular/core';

@Component({
  selector: 'mprd-modem-choice-onts-skeleton',
  templateUrl: './modem-choice-onts-skeleton.component.html',
})
export class ModemChoiceOntsSkeletonComponent {}
